import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { LoginCustomization } from '@core/interfaces';

@Component({
  selector: 'auth-email-step',
  templateUrl: './email-step.template.html'
})
export class EmailStepComponent {
  @Input()
  public isLoading: boolean;

  @Input()
  public loginForm: FormGroup;

  @Input()
  public loginCustomization: LoginCustomization;

  @Output()
  public toPasswordStep: EventEmitter<void>;

  constructor() {
    this.toPasswordStep = new EventEmitter<void>();
  }
}
